export enum ServiceStatus {
	Canceled = 'canceled',
	Terminated = 'terminated'
}
